document.addEventListener('DOMContentLoaded', function() {
  var swatches = document.querySelectorAll('.media-swatch');
  swatches.forEach(function(swatch) {
    swatch.addEventListener('click', function() {
      var variantId = this.getAttribute('data-variant-id');
      // Beispiel, um das hervorzuhebende Icon zu bestimmen; an deine Logik anpassen
      var highlightIconId = 'caticon-' + variantId; // Beispiel-Logik

      // Entferne Highlight von allen Icons
      document.querySelectorAll('#product-icons .product-icon').forEach(function(icon) {
        icon.classList.remove('highlighted');
      });

      // Füge Highlight zum entsprechenden Icon hinzu
      var iconToHighlight = document.querySelector('#product-icons .product-icon[data-icon-id="' + highlightIconId + '"]');
      if(iconToHighlight) {
        iconToHighlight.classList.add('highlighted');
      }
    });
  });
});
